export enum ELegalEntityTypes {
  individual = 'individual',
  organisation = 'organisation',
}
